export default "__VITE_ASSET__I9C3eJ58__"